<template>
  <div>
    <b-row>
      <b-col cols="2" xl="1">
        <md-button class="md-raised" @click="update" >{{$t('Refresh')}}</md-button>
      </b-col>
      <b-col cols="2" xl="2">
        <md-field>
          <label>{{$t('Username')}}</label>
          <md-input v-model="username"></md-input>
        </md-field>
      </b-col>
      <b-col cols="2" xl="2">
        <md-field>
          <label>{{$t('Phone')}}</label>
          <md-input v-model="phone"></md-input>
        </md-field>
      </b-col>
      <b-col cols="2" xl="2">
        <md-field>
          <label>{{$t('Email')}}</label>
          <md-input v-model="email"></md-input>
        </md-field>
      </b-col>
      <b-col cols="1" xl="1">
        <md-button class="md-raised" @click="addUser" >{{$t('Add')}}</md-button>
      </b-col>
    </b-row>
    <basic-table
        v-if="tv24Users"
        :items="tv24Users"
        :fields="fields"
        @ClickOnEditButton="editItem"
        :isDelete="false"
        :isEdit="true" show-empty/>
    <table-manager-bottom-small
        :totalRows="tv24UsersTotal" :perPage="perPage"
        v-model="currentPage"/>
    <userInfo :userInfo="selectedUser"/>
    <formUsers @addUser="sendAddUser" :tv24Users="tv24Users"/>
    <modalAdd24TVUser :editItem="addUserData" @update="update"/>
  </div>
</template>

<script>
import userInfo from './userInfo'
import formUsers from './formUsers'
import modalAdd24TVUser from './modalAdd24TVUser'

export default {
  components: {
    userInfo,
    formUsers,
    modalAdd24TVUser
  },
  data () {
    return {
      username: '',
      email: '',
      phone: '',
      fields: [
        {key: 'id', label: '24TV ID'},
        {key: 'provider_uid', label: 'Billing account ID'},
        {key: 'username', label: 'username'},
        {key: 'email', label: 'Email'},
        {key: 'phone', label: 'Phone'},
        {key: 'actions', label: this.$i18n.t('Actions')}
      ],
      perPage: 20,
      currentPage: 1,
      selectedUser: null,
      addUserData: null
    }
  },
  methods: {
    update () {
      if (this.currentPage === 1) {
        this.$store.dispatch('Settings/GET_TV_24_USERS', {'limit': this.perPage,
          'offset': (this.currentPage - 1) * this.perPage,
          'username': this.username,
          'phone': this.phone,
          'email': this.email})
      } else {
        this.currentPage = 1
      }
    },
    sendAddUser (userData) {
      let tmp = JSON.parse(JSON.stringify(userData))
      this.addUserData = tmp
      this.$root.$emit('bv::show::modal', 'modalEditDataAddUser', '#btnShow')
    },
    editItem (item) {
      this.selectedUser = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEdit24TVUser', '#btnShow')
    },
    paginationChanged (value) {
      this.perPage = value
    },
    addUser () {
      this.$root.$emit('bv::show::modal', 'modalChooseUser', '#btnShow')
    }
  },
  computed: {
    tv24Users () {
      return this.$store.getters['Settings/TV_24_USERS'].items
    },
    tv24UsersTotal () {
      return 10000
      // return this.$store.getters['Settings/TV_24_USERS'].total
    }
  },
  watch: {
    currentPage (val) {
      this.$store.dispatch('Settings/GET_TV_24_USERS', {'limit': this.perPage,
        'offset': (val - 1) * this.perPage,
        'username': this.username,
        'phone': this.phone,
        'email': this.email})
    },
    perPage (val) {
      this.$store.dispatch('Settings/GET_TV_24_USERS', {'limit': val,
        'offset': (this.currentPage - 1) * val,
        'username': this.username,
        'phone': this.phone,
        'email': this.email})
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_TV_24_USERS', {'limit': 20,
      'offset': 0,
      'username': this.username,
      'phone': this.phone,
      'email': this.email})
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/users.vue